__webpack_require__.p = "/blackjackSimulator/";